/**
 * Accounting's zoom (STORY-186) — how large the screen is drawn, as a percent.
 *
 * **A per-person display preference, so it lives in this browser** and nowhere
 * else: it is not clinic data, it reaches no server, and a colleague on another
 * screen keeps their own. Every read and write is guarded, because storage can
 * be blocked (a private window, cleared site data) and the screen must draw
 * either way, at the default.
 */

/** The sizes offered, smallest first. */
export const ZOOM_STEPS = [60, 70, 80, 90, 100, 110, 120] as const;

/** Where it opens until somebody chooses: smaller than the browser's own size. */
export const DEFAULT_ZOOM = 80;

export const ZOOM_KEY = "dentacore.accounting.zoom";

/**
 * A stored value as one of the offered sizes, or the default for anything else —
 * a missing value, text, or a size an earlier version offered. Never throws.
 */
export function parseZoom(stored: string | null | undefined): number {
  if (stored === null || stored === undefined) return DEFAULT_ZOOM;
  const value = Number(stored);
  return (ZOOM_STEPS as readonly number[]).includes(value) ? value : DEFAULT_ZOOM;
}

export function readZoom(): number {
  try {
    return parseZoom(window.localStorage.getItem(ZOOM_KEY));
  } catch {
    return DEFAULT_ZOOM;
  }
}

export function writeZoom(value: number): void {
  try {
    window.localStorage.setItem(ZOOM_KEY, String(value));
  } catch {
    // Storage is blocked: the choice holds for this visit and is not remembered.
  }
}
